import React from 'react';

const SectionDivider = ({ color = 'blue', size = 'medium' }) => {
  const colorClasses = {
    blue: 'from-cyber-blue/20 via-cyber-blue/40 to-cyber-blue/20',
    purple: 'from-cyber-purple/20 via-cyber-purple/40 to-cyber-purple/20',
    green: 'from-cyber-green/20 via-cyber-green/40 to-cyber-green/20',
    gold: 'from-cyber-gold/20 via-cyber-gold/40 to-cyber-gold/20'
  };

  const sizeClasses = {
    small: 'h-16',
    medium: 'h-24',
    large: 'h-32'
  };

  const dotSizes = {
    small: 'w-3 h-3',
    medium: 'w-4 h-4',
    large: 'w-6 h-6'
  };

  return (
    <div className={`relative ${sizeClasses[size]} flex items-center justify-center z-20`}>
      {/* Gradient Line */}
      <div className={`absolute inset-0 bg-gradient-to-r ${colorClasses[color]} h-px`}></div>
      
      {/* Animated Dot */}
      <div className={`absolute ${dotSizes[size]} bg-cyber-${color} rounded-full animate-glow-pulse`}></div>
      
      {/* Floating Elements */}
      <div className="absolute left-1/4 w-1 h-1 bg-cyber-blue/60 rounded-full animate-float opacity-60"></div>
      <div className="absolute right-1/4 w-1 h-1 bg-cyber-gold/60 rounded-full animate-float-delayed opacity-60"></div>
    </div>
  );
};

export default SectionDivider;
